import React from "react";

/** A headline number with its working underneath. */
export default function Stat({ label, value, sub, color, testid }) {
  return (
    <div className="glass p-5 fade-up" data-testid={testid}>
      <div className="text-[10px] uppercase tracking-wider font-mono text-ink-3 mb-1.5">{label}</div>
      <div className="font-display text-2xl md:text-3xl font-bold tracking-tight tabular-nums" style={{ color }}>{value}</div>
      {sub && <div className="text-[11px] text-ink-3 mt-1 leading-snug">{sub}</div>}
    </div>
  );
}
